// DEV ONLY: localhost/?demo shows things that can't be seen on demand —
// a live NFL game, a live F1 race, and you winning last month's jackpot.
// Screen only: nothing is written to the database. Removed from production builds.
export const isDemo = () => process.env.NODE_ENV === 'development' && typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).has('demo');

// the first NFL game that hasn't started: 3rd quarter, 8:42 left
export function demoNfl(games) {
  if (!isDemo() || !games?.length) return games;
  let done = false;
  return games.map((g) => {
    if (done || g.status !== 'FUT') return g;
    done = true;
    return { ...g, status: 'LIVE', period: 3, game_clock: '8:42', home_score: 17, away_score: 20 };
  });
}

// the open F1 race: lights out 38 minutes ago
export function demoF1(races) {
  if (!isDemo() || !races?.length) return races;
  let done = false;
  return races.map((r) => {
    if (done || !r.bettable) return r;
    done = true;
    return { ...r, status: 'LIVE', bettable: false, race_time: new Date(Date.now() - 38 * 60000).toISOString(), game_time: new Date(Date.now() - 38 * 60000).toISOString() };
  });
}

// jackpot: a filled pot this month, and October as it really ended, with Marc88 in raph's 2nd place
export function demoJackpot(profile) {
  if (!isDemo()) return null;
  const pot = 67905;
  return {
    pot: 2360, tickets: 7,
    last: {
      month: '2026-10', pot,
      winners: [
        { place: 1, user_id: 'demo-1', username: 'Caroline', amount: Math.round(pot * 0.6 * 100) / 100 },
        { place: 2, user_id: 'demo-2', username: 'Marc88', amount: Math.round(pot * 0.3 * 100) / 100, replaced: 'raph' },
        { place: 3, user_id: 'demo-3', username: 'DI4N3', amount: Math.round(pot * 0.1 * 100) / 100 },
      ],
    },
  };
}

// the demo live NFL game's panel: team stats + scoring plays
export function demoNflStats(game) {
  if (!isDemo() || game?.status !== 'LIVE' || !game.model) return null;
  return {
    away: { abbrev: game.away_abbrev, stats: { totalYards: 312, passingYards: 214, rushingYards: 98, firstDowns: 17, turnovers: 1, sacks: 2, thirdDown: '5-11', possession: '21:48', possessionSec: 1308, penalties: '4-35' } },
    home: { abbrev: game.home_abbrev, stats: { totalYards: 287, passingYards: 171, rushingYards: 116, firstDowns: 15, turnovers: 0, sacks: 3, thirdDown: '4-10', possession: '16:30', possessionSec: 990, penalties: '6-48' } },
    scoringPlays: [
      { period: 3, clock: '9:05', team: game.away_abbrev, type: 'goal', kind: 'TD', text: 'Wide receiver 23 Yd pass from the quarterback (Kick)', awayScore: 20, homeScore: 17 },
      { period: 2, clock: '0:04', team: game.home_abbrev, type: 'score', kind: 'FG', text: 'Kicker 47 Yd Field Goal', awayScore: 13, homeScore: 17 },
      { period: 2, clock: '6:12', team: game.home_abbrev, type: 'goal', kind: 'TD', text: 'Running back 4 Yd Run (Kick)', awayScore: 13, homeScore: 14 },
      { period: 2, clock: '11:20', team: game.away_abbrev, type: 'goal', kind: 'TD', text: 'Tight end 11 Yd pass from the quarterback (Kick)', awayScore: 13, homeScore: 7 },
      { period: 1, clock: '2:48', team: game.home_abbrev, type: 'goal', kind: 'TD', text: 'Wide receiver 38 Yd pass from the quarterback (Kick)', awayScore: 6, homeScore: 7 },
      { period: 1, clock: '9:31', team: game.away_abbrev, type: 'goal', kind: 'TD', text: 'Running back 2 Yd Run (Kick failed)', awayScore: 6, homeScore: 0 },
    ],
  };
}
// the demo live F1 race's running order
export function demoF1Live(race) {
  if (!isDemo() || race?.status !== 'LIVE' || !race.model) return null;
  const comps = ['MEDIUM', 'HARD', 'SOFT'];
  const order = race.model.drivers.map((dr, i) => ({
    pos: i + 1, code: dr.code, name: dr.name, team: dr.team, color: null,
    gap: i === 0 ? 'LEADER' : `+${(i * 2.7 + (i % 3) * 0.9).toFixed(3)}`, interval: i === 0 ? '' : `+${(2.1 + (i % 4) * 0.6).toFixed(3)}`, pits: i % 5 === 0 ? 2 : 1,
    tyre: { compound: comps[i % 3], age: 6 + (i * 3) % 17 },
    last: `1:${(38.2 + (i % 7) * 0.31).toFixed(3)}`, best: `1:${(37.1 + (i % 9) * 0.22).toFixed(3)}`, fastest: i === 2,
  }));
  const control = [
    { lap: 33, category: 'Other', flag: null, message: 'FIA STEWARDS: 5 SECOND TIME PENALTY FOR CAR 18 (STR) - LEAVING THE TRACK AND GAINING AN ADVANTAGE' },
    { lap: 29, category: 'Flag', flag: 'GREEN', message: 'TRACK CLEAR' },
    { lap: 26, category: 'SafetyCar', flag: null, message: 'SAFETY CAR IN THIS LAP' },
    { lap: 23, category: 'SafetyCar', flag: null, message: 'SAFETY CAR DEPLOYED' },
    { lap: 1, category: 'Other', flag: null, message: 'DRS ENABLED' },
  ];
  return { state: 'live', available: true, lap: 34, totalLaps: 56, order, control, weather: { air: 31.4, track: 46.8, rain: false, humidity: 71, wind: 1.8 } };
}
